import React, { Component } from 'react';

import DeviceCard from './DeviceCard';

import Grid from 'material-ui/Grid';

class Devices extends Component {
  render() {
    const devices = this.props.devices;

    return (
      <div className="deviceList">
        <Grid container spacing={8} justify="center">
          <Grid container spacing={8} justify="center" xs={10}>
            {devices.map(device =>
              <DeviceCard device={device} key={device.name} />
            )}
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default Devices;



// WEBPACK FOOTER //
// ./src/components/Devices.js